export function addressValidator(address) {
    if (!address) return "Address can't be empty.";
    return "";
  }